import { TalentIntroducedToCustomerStatus } from "../../../../talents/types/queries";
import { Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  status: TalentIntroducedToCustomerStatus;
  withOrder?: boolean;
};

const TalentIntroductionStatus = ({ status, withOrder }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const disabledColor = theme.typography.disabled;
  const successColor = theme.palette.success.main;

  const statusComponents = {
    [TalentIntroducedToCustomerStatus.Introduced]: (
      <Typography variant="body2" color="textSecondary">
        {t("talentProfile:profileSummary.introducing")}
      </Typography>
    ),
    [TalentIntroducedToCustomerStatus.Approved]: (
      <Typography fontSize="14px" sx={{ color: successColor }}>
        {withOrder
          ? t("order:customerApprovedDisplayName")
          : t("talentProfile:Approved")}
      </Typography>
    ),
    [TalentIntroducedToCustomerStatus.Interview]: (
      <Typography variant="body2" color="textSecondary">
        {t("talentProfile:introductions.statuses.INTERVIEW")}
      </Typography>
    ),
    [TalentIntroducedToCustomerStatus.Offered]: (
      <Typography variant="body2" color="textSecondary">
        {t("order:offeredDisplayName")}
      </Typography>
    ),
    [TalentIntroducedToCustomerStatus.Accepted]: (
      <Typography fontSize="14px" sx={{ color: successColor }}>
        {t("talentProfile:introductions.statuses.ACCEPTED")}
      </Typography>
    ),
    [TalentIntroducedToCustomerStatus.EezyRejected]: (
      <Typography fontSize="14px" sx={{ color: disabledColor }}>
        {t("talentProfile:introductions.statuses.EEZY_REJECTED")}
      </Typography>
    ),
    [TalentIntroducedToCustomerStatus.Withdrew]: (
      <Typography fontSize="14px" sx={{ color: disabledColor }}>
        {t("talentProfile:introductions.statuses.WITHDREW")}
      </Typography>
    ),
    [TalentIntroducedToCustomerStatus.Cancelled]: (
      <Typography fontSize="14px" sx={{ color: disabledColor }}>
        {t("common:cancelledAlt")}
      </Typography>
    ),
    [TalentIntroducedToCustomerStatus.Rejected]: (
      <Typography fontSize="14px" sx={{ color: disabledColor }}>
        {t("common:rejected")}
      </Typography>
    ),
  };

  return statusComponents[status];
};

export default TalentIntroductionStatus;
